import { render, staticRenderFns } from "./ModuleSwapRates.vue?vue&type=template&id=a54dc608&scoped=true"
import script from "./ModuleSwapRates.vue?vue&type=script&lang=js"
export * from "./ModuleSwapRates.vue?vue&type=script&lang=js"
import style0 from "./ModuleSwapRates.vue?vue&type=style&index=0&id=a54dc608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54dc608",
  null
  
)

export default component.exports